import { render, staticRenderFns } from "./fashionClothes.vue?vue&type=template&id=76a64b18&"
import script from "./fashionClothes.vue?vue&type=script&lang=js&"
export * from "./fashionClothes.vue?vue&type=script&lang=js&"
import style0 from "./fashionClothes.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports